import { MoneyValueDto } from '@/types/MoneyValueDto.ts';
import { moneyListDirection } from '@/features/dashboard/bookingChanges/utils/money.ts';
import { MAX_REJECTION_COMMENT_LENGTH } from '@/features/public/bookingSummary/schemas/rejectPendingChangeSchema.ts';

/** Napisy panelu zmian czekających na zgodę zapisującego. */

export const PENDING_CHANGE_HEADING = 'Zmiany czekają na Twoją zgodę';

export const PENDING_CHANGE_INTRO =
  'Organizator przygotował zmiany w Twojej rezerwacji. Do czasu Twojej decyzji rezerwacja działa na dotychczasowych warunkach — poniżej to, co się zmieni.';

/** Co stanie się z ratami po akceptacji; zależy od kierunku kwoty. */
export const pendingChangeSettlementSentence = (
  balance: MoneyValueDto[],
): string => {
  switch (moneyListDirection(balance)) {
    case 0:
      return 'Te zmiany nie wpływają na kwotę rezerwacji — harmonogram rat zostaje bez zmian.';
    case 1:
      return 'Dopłata wejdzie w raty jeszcze nieopłacone, proporcjonalnie do ich wysokości. Terminy zostają bez zmian.';
    case -1:
      return 'Zwrot obniży raty jeszcze nieopłacone. Terminy zostają bez zmian.';
    default:
      return 'Zmiana obejmuje więcej niż jedną walutę — każda wejdzie w raty prowadzone w tej samej walucie.';
  }
};

export const PENDING_CHANGE_AMENDMENT =
  'Razem ze zmianami zaakceptujesz zaktualizowane dokumenty rezerwacji.';

/**
 * Dopisek pod przyciskami. O terminie ważności linku nie ma tu słowa, bo takiego
 * terminu nie ma: paczka nie wygasa sama, zdjąć ją może wyłącznie organizator.
 *
 * Nie obiecujemy, że organizator się odezwie: komentarz trafia na paczkę, ale
 * nikt nie dostaje powiadomienia, więc przy pilnej sprawie inicjatywa zostaje
 * po stronie klienta i mówimy mu to wprost.
 */
export const PENDING_CHANGE_FOOTNOTE =
  'Odrzucenie zostawia rezerwację bez zmian. Możesz napisać, co nie pasuje — organizator zobaczy to przy rezerwacji. Nowe warunki musiałby przygotować od nowa, więc jeśli sprawa jest pilna — skontaktuj się z nim.';

/** Odrzucenie jest nieodwracalne, więc okno mówi to, zanim klient je potwierdzi. */
export const REJECT_DIALOG = {
  title: 'Odrzucić zmiany?',
  description:
    'Rezerwacja zostanie na dotychczasowych warunkach. Tej decyzji nie da się cofnąć — jeśli zmienisz zdanie, organizator będzie musiał przygotować propozycję od nowa.',
  commentLabel: 'Komentarz dla organizatora (opcjonalnie)',
  commentHint: `Napisz, co nie pasuje — organizator zobaczy to przy paczce. Do ${MAX_REJECTION_COMMENT_LENGTH} znaków.`,
  cancelText: 'Anuluj',
  confirmText: 'Odrzuć zmiany',
} as const;
